module.exports = __webpack_public_path__ + "b449ddc57d09976d95e66ea9d3c5b9.svg";